export default (field, text) => async (dispatch) => {
  dispatch({ type: 'TEAM/CHANGE_TEXT', payload: { field, text } });
};
